import { List, ListItem, ListItemButton, ListItemText, useTheme } from '@mui/material';
import { NavLink } from 'react-router-dom';

export interface NavLinkButton {
    text: string;
    path: string;
    children?: NavLinkButton[];
}

interface NavDrawerButtonProps {
    button: NavLinkButton;
    inset?: boolean;
    toggle(): void;
}

export function NavDrawerButton({ button, inset, toggle }: NavDrawerButtonProps) {
    const theme = useTheme();
    const { path, text, children } = button;

    if (!children) {
        return (
            <ListItemButton
                component={NavLink}
                to={path}
                activeStyle={{
                    backgroundColor: theme.palette.action.selected,
                }}
                exact
                onClick={toggle}
            >
                <ListItemText inset={inset} primary={text} />
            </ListItemButton>
        );
    }

    return (
        <>
            <ListItem>
                <ListItemText primary={text} />
            </ListItem>
            <List component='div' disablePadding>
                {children.map(button => (
                    <NavDrawerButton inset key={button.text} button={button} toggle={toggle} />
                ))}
            </List>
        </>
    );
}
